import Product from '../../components/product/Product';

const Home = () => {
  return (
    <div>
      <Product />
    </div>
  );
};

export default Home;
